// extracted by mini-css-extract-plugin
export var cardIcon = "_a0-4";
export var checkboxCard = "_a0-0";
export var checkboxCardSelected = "_a0-3";
export var disabled = "_a0-1";
export var outerBorder = "_a0-2";
export var spacerMedium = "_a0-7";
export var spacerSmall = "_a0-6";
export var spacerXsmall = "_a0-5";